import { Filter, FilterTypes } from 'components/FilterDrawer/FilterDrawer.config'
import { FilterOptions } from './types'

export const filtersInitialState: Filter[] = [
  {
    type: FilterTypes.RANGE,
    name: 'dateYear',
    label: 'Years Range',
    value: [],
    step: 1,
  },
  {
    type: FilterTypes.KEYWORD,
    name: 'jobDepartment',
    label: 'Departments',
    value: [],
  },
  {
    type: FilterTypes.KEYWORD,
    name: 'displayJurisdiction',
    label: 'Locations',
    value: [],
  },
  {
    type: FilterTypes.BOOL,
    name: 'numExecutives',
    label: 'Present Executives Only',
    activeFilterLabel: 'Executives Only',
    value: [],
  },
]

export const legendData = [
  { label: 'Local', color: '#2257C5' },
  { label: 'Non-local', color: '#FF5837' },
]

export const formatFilterOptions = (filterOptions: FilterOptions) => {
  // Take maximum of 10 years ago
  if (filterOptions?.dateYear?.[0]?.value) {
    const [from, to] = filterOptions.dateYear?.[0]?.value || []
    const minYear = Math.max(from, new Date().getFullYear() - 10)
    filterOptions.dateYear[0].value = [minYear, to]
  }
  return filterOptions
}

export const formatChartData = (chartData?: any[]) =>
  // Filter out data from before 10 years ago
  chartData?.filter(item => item.year >= new Date().getFullYear() - 10)
